/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShieldChevron = createReactComponent("shield-chevron", "IconShieldChevron", [
  [
    "path",
    {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3",
      key: "svg-0"
    }
  ],
  ["path", { d: "M4 14l8 -3l8 3", key: "svg-1" }]
]);

export { IconShieldChevron as default };
//# sourceMappingURL=IconShieldChevron.js.map
